<template>

          <!----------- links ---------------------------------->
          <div class="column is-12">
            <div class="box">
              <div class="columns">
                <div class="column is-12">
                  <label class="label">{{ elLabel }}</label>
                  <div class="field has-addons">

                    <div class="control has-icons-right">
                      <input
                      class="input"
                      v-model="link.url"
                      name="linkurl" 
                      v-validate="'url:require_protocol'"
                      placeholder="URL mit https://">
                      <span class="icon is-right" v-show="errors.has('linkurl')"><i class="fa fa-warning"></i></span><span v-show="errors.has('linkurl')" class="help is-danger">URL ungültig</span>
                    </div>
                    <div class="control has-icons-right  is-expanded">
                      <input
                      class="input"
                      v-model="link.caption"
                      maxlength="30"
                      name="linkcaption" 
                      v-validate=""
                      placeholder="Link-Button Text">
                      <span class="icon is-right" v-show="errors.has('linkcaption')"><i class="fa fa-warning"></i></span><span v-show="errors.has('linkcaption')" class="help is-danger">Benötigtes Feld</span>
                    </div>
                    <div class="control">
                      <a class="button is-info" v-if="link.url.length && !errors.has('linkurl') && link.caption.length" @click="addLink">
                        Hinzufügen
                      </a>
                    </div>
                  </div>
                </div>
              </div>

                <draggable v-model="n" :options="{draggable:'.column', handle:'.my-handle'}" class="columns is-multiline">
                <div class="column is-12 my-handle" v-for="(i, index) in n" :key="index">
                  <a class="delete is-pulled-left" style="margin-right: 10px;" @click="$emit('linkWasDeleted', index)"></a>{{ i.url }} - {{ i.caption }} 
                </div>
              </draggable>
            </div>
          </div>

</template>

<script>
import draggable from 'vuedraggable'
export default {
  inject: ['$validator'],
  props: ['data', 'elLabel'],
  data () {
    return {
      link: { caption: '', url: '' }
    }
  },
  methods: {
    addLink () {
      if (this.link.url.length && !this.$validator.errors.has('linkurl') && !this.$validator.errors.has('linkcaption')) {
        this.$emit('linkWasAdded', this.link)
        this.link = { caption: '', url: '' }
      }
    }
  },
  computed: {
    n: {
      get () {
        return this.data
      },
      set (value) {
        this.$emit('wasSorted', value)
      }
    }
  },
  components: {
    draggable
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/cms/elements/Links.vue